import { render, staticRenderFns } from "./NewAmenities.vue?vue&type=template&id=1cfaa9cb&"
import script from "./NewAmenities.vue?vue&type=script&lang=js&"
export * from "./NewAmenities.vue?vue&type=script&lang=js&"
import style0 from "./NewAmenities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports